import { useMemo } from 'react';
import {
  createNotificationsClient,
  type NotificationsClient,
} from '../api/notificationsClient.js';
import { useAuth } from '../auth/AuthContext.js';

/**
 * Bind a single {@link NotificationsClient} to the current auth session, mirroring
 * {@link useShowClient}. The client reads the access token through the getter on each request so
 * silent refresh is transparent (§32.3).
 */
export function useNotificationsClient(): NotificationsClient {
  const { getAccessToken } = useAuth();
  return useMemo(() => createNotificationsClient(getAccessToken), [getAccessToken]);
}
